<template>
  <div class="face">
    <div class="face-box" v-if="isSuccessful == 1">
      <div class="face-box_title">
        <b>人脸识别</b>
        <p>请衣着整齐，平视摄像头，并正对光源</p>
        <div><span>{{msgData}}</span></div>
      </div>
      <div class="face-box_content" style="width: 280px; height: 280px;">
        <span class="b1"></span>
        <span class="b2"></span>
        <span class="b3"></span>
        <span class="b4"></span>
        <em></em>
        <video id="video" playsinline autoplay x5-video-player-type="h5" style="object-fit:fill;width: 280px; height: 280px;"></video>
      </div>
      <canvas id="canvas" width="300" height="300" style="display: none;"></canvas>
      <div class="faceDivSuccessful" v-if="msgData != '现在进行人脸识别...'">
        <br />
        <p>请拨打下方电话，联系管理员</p>
        <!-- <p>023-62652911,023-62652917</p> -->
        <el-button class="refer-btn" type="primary" @click="setSuccessful">重新识别</el-button>
      </div>
    </div>

    <div class="faceDivSuccessful" v-if="isSuccessful === 2">
      <img src="../assets/images/faceSuccessful.png" alt="" />
      <p>
        已识别成功<br />点击下方按钮
        <template v-if="isTest">去开始考试</template>
      </p>
      <el-button class="refer-btn" type="primary" @click="isRouter()">
        {{ isTest ? "开始考试" : "下一步" }}
      </el-button>
    </div>

  </div>
</template>

<script>

import { faceServe } from "@/api/home";
import { putObject } from "../utils/upload";
import {getStore} from "../utils/localStorage";

export default {
  name: "face",
  props: {
    isTest: {
      type: Boolean,
      default: false,
    },
    examBasicUuid: {
      type: String,
      default: "",
    },
    classId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      mediaStreamTrack : null,
      isSuccessful: 1,
      msgData: "现在进行人脸识别...",
      isIdentify:false,
      video:null,
      canvas:null,
      ctx:null,
      routerPath: '',
    };
  },
  mounted() {

    this.routerPath = this.$route.path;
    let a = setTimeout(()=>{
      this.openUserMedia()
      clearTimeout(a)
    },1000)
  },
  methods: {
    openUserMedia() {

      if (
        navigator.mediaDevices.getUserMedia ||
        navigator.webkitGetUserMedia ||
        navigator.mozGetUserMedia ||
        navigator.getUserMedia
      ) {
        this.video = document.getElementById('video');
        this.canvas = document.getElementById('canvas');
        this.ctx = this.canvas.getContext('2d');
        let w = this.video.offsetWidth;
        let h = this.video.offsetHeight;
        this.getUserMediaToPhoto(
          {video: {width: w,height: h,audio: true,facingMode: "user"}},
          this.success,
          this.error
        );
      } else {
        this.isSuccessful = 1;
        this.msgData = "你的浏览器不支持访问用户媒体设备";
      }
    },

    success(stream) {
      this.mediaStreamTrack = null;
      this.mediaStreamTrack = stream;
      try {
        this.video.srcObject = stream;
      } catch (e) {
        this.video.src = window.URL.createObjectURL(stream);
        this.isSuccessful = 1;
        this.msgData = e.message;
        console.log("访问用户媒体设备失败：", e.name, e.message);
      }
      this.video.play(); //播放视频
      let a = setTimeout(()=>{
        this.takePhoto();
        clearTimeout(a)
      },3000)
    },

    error(error) {
      console.log("访问用户媒体失败：", error.name,  error.message );
      this.isSuccessful = 1;
      this.msgData = "浏览器未检测到摄像头";
    },

    getUserMediaToPhoto(constraints, success, error) {
      if (navigator.mediaDevices.getUserMedia) {
        navigator.mediaDevices
          .getUserMedia(constraints)
          .then(success)
          .catch(error);
      } else if (navigator.webkitGetUserMedia) {
        navigator.webkitGetUserMedia(constraints, success, error);
      } else if (navigator.mozGetUserMedia) {
        navigator.mozGetUserMedia(constraints, success, error);
      } else if (navigator.getUserMedia) {
        navigator.getUserMedia(constraints, success, error);
      }
    },

    // 截取图像
    takePhoto(){
      let w = this.video.offsetWidth;
      let h = this.video.offsetHeight;
      this.ctx.drawImage(video, 0, 0, w, h);
      let img = this.canvas.toDataURL('image/jpeg');
      img = this.dataURLtoFile(img,'tmp.jpg')
      this.uploadCos(img)
    },

    // 关闭摄像头
    closeMedia() {
      this.mediaStreamTrack.getTracks()[0].stop();
      this.mediaStreamTrack = null;
    },

    //将base64转换为文件
    dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
      while(n--){
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, {type:mime});
    },


    // 重新识别
    setSuccessful(){
      this.msgData = "现在进行人脸识别..."
      this.isIdentify = false
      this.takePhoto();
    },

    isRouter() {
      this.$emit("isRouter");
    },

    // 上传截图
    uploadCos(file) {
      const entranceType = localStorage.getItem('_ENTRANCETYPE')
      let iType = 0;
      entranceType == 'own' ? iType = 1 : iType = 2;
      putObject(file, (res) => {
        faceServe
          .personVerify({
            face_img: res,
            class_id:this.classId,
            type:iType,
          })
          .then((data) => {
            if (data.data.code !== 200) {
              this.isSuccessful = 1;
              this.msgData = data.data.msg;
              this.isIdentify = true
            } else {
              this.isSuccessful = 2;
              this.closeMedia();
            }
          })
          .catch((res) => {
            this.isSuccessful = 1;
            this.msgData = '人脸验证未通过';
            this.isIdentify = true
          });
      });
    },

  },
};
</script>

<style scoped lang="scss">
.face{
  background: #fff;
  border-radius: 10px;
  padding:10px 20px;
  min-width: 480px;
  min-height: 540px;
  display: flex;
  justify-content: center;
  align-items: center;
  &-box{
    &_title{
      text-align: center;
      p{
        font-size: 16px;
        color: #333;
      }
      div{
        font-size: 14px;
        padding: 10px 0;
      }
      span{
        color: #1F6EB7;
      }
      b{
        color: red;
        font-style: normal;
      }
      em{
        color: green;
        font-weight: normal;
      }

    }
    &_content{
      position: relative;
      width: 280px;
      height: 280px;
      span{
        position: absolute;
        width: 50px;
        height: 50px;
        box-sizing: border-box;
        &.b1{
          left: 0;
          top: 0;
          border-top: 4px solid #1F6EB7;
          border-left: 4px solid #1F6EB7;
        }
        &.b2{
          right: 0;
          top: 0;
          border-top: 4px solid #1F6EB7;
          border-right: 4px solid #1F6EB7;
        }
        &.b3{
          left: 0;
          bottom: 0;
          border-bottom: 4px solid #1F6EB7;
          border-left: 4px solid #1F6EB7;
        }
        &.b4{
          right: 0;
          bottom: 0;
          border-bottom: 4px solid #1F6EB7;
          border-right: 4px solid #1F6EB7;
        }
      }
      em{
        position: absolute;
        width: 100%;
        height: 2px;
        background: #1F6EB7;
        top: 0;
        left: 0;
        font-style: normal;
        animation:topMove linear 2s infinite alternate;
        /* Firefox: */
        -moz-animation:topMove linear 2s infinite alternate;
        /* Safari and Chrome: */
        -webkit-animation:topMove linear 2s infinite alternate;
        /* Opera: */
        -o-animation:topMove linear 2s infinite alternate;
      }
    }

    &_btn{
      display: flex;
      justify-content: center;
      padding-top: 20px;
    }
  }
  .faceDivSuccessful {
    display: flex;
    flex-direction: column;
    align-items: center;
    strong {
      margin-bottom: 20px;
      font-size: 15px;
      color: #333;
    }
    p {
      font-size: 14px;
      color: #999;
    }
    .pButton {
      margin: 5px 0 0;
    }
    img {
      margin: 0 0 25px;
    }
    .auditImg {
      margin: 150px 0 25px;
    }
    .el-button{
      margin-top: 20px;
    }
  }

}

@keyframes topMove
{
  from {top: 0;}
  to {top: 100%;}
}
@-moz-keyframes topMove
{
  from {top: 0;}
  to {top: 100%;}
}
@-webkit-keyframes topMove
{
  from {top: 0;}
  to {top: 100%;}
}
@-o-keyframes topMove
{
  from {top: 0;}
  to {top: 100%;}
}
</style>
